import OrderBasket from '@/modules/basket/components/product-in-order/index.vue';
import deliveryNovaPoshta from '@/modules/basket/components/delivery-nova-poshta/index.vue'
import deliveryCourier from '@/modules/basket/components/delivery-courier/index.vue'
import autocomplete from '@/components/autocomplete/index.vue'
import mainSelect from '@/components/main-select/index.vue'
import {TheMask} from 'vue-the-mask'
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: 'order',
    components: {
        OrderBasket,
        deliveryNovaPoshta,
        deliveryCourier,
        autocomplete,
        mainSelect,
        TheMask
    },

    data() {
        return {
            selected: '',
            edit: false,
            typeDelivery: {},
            name: '',
            phone: '',
            value: '',
            city: '',
            street: '',
            pidyizd: '',
            home: '',
            flat: '',
            currentPayment: {},
            orderSent: false,
            isValid: false,
            department: '',
            payload: {
                name: '',
                phone: '',
                last_name: ''
            },
            errors: {
                name: false,
                last_name: false,
                phone: false,
                delivery: false,
                city: false,
                department: false,
                payment: false,
                street: false,
                home: false,

            }

        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            getCurrentOrder: 'order/getCurrentOrder',
            getUserInfo: 'userData/userInfo',
            orderStatus: 'order/currentOrder',
            ordersMethods: 'order/ordersMethods',
            selectTown: 'order/address',
            successBuy: 'order/successBuy',
            currentOrder: 'order/currentOrder',
            isAuthenticated: 'order/isAuthenticated'
        }),
        getTotalPrice() {
            let arr = []
            this.getCurrentOrder.forEach(product => {
                arr.push(product.sum)
            })
            let sum = arr.reduce((a, b) => a + b, 0)
            return sum
        }
    },
    methods: {
        ...mapActions({
            submitOrder: 'order/CURRENT_ORDER',
            getUserData: 'userData/GET_DATA',
            orderMethods: 'order/ORDERS_METHODS',
            createOrder: 'order/CREATE_ORDER'
        }),
        ...mapMutations({
            resetBasket: 'order/RESET_BASKET',
            changeShowThanksOrder: 'order/THANKS_ORDER',
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
        }),

        userData() {
            this.payload.name = this.getUserInfo.name
            this.payload.phone = this.getUserInfo.phone
            this.payload.last_name = this.getUserInfo.lastName
            this.payload.city = this.selectTown.town
            this.payload.department = this.selectTown.department
            this.street = ''
            this.flat = ''
        },
        submit() {
            let obj = {}
            obj.user_name = this.payload.name
            obj.user_phone = this.payload.phone
            obj.user_last_name = this.payload.last_name
            obj.delivery_method_id = this.typeDelivery.id
            obj.payment_method_id = this.currentPayment.id
            obj.city = this.selectTown.town
            obj.address = {
                street: this.street,
                flat: this.flat,
                pidyizd: this.pidyizd,
                build: this.home,
                post_number: this.selectTown.department
            }
            obj.products = []

            this.getCurrentOrder.forEach(product => {
                obj.products.push({
                    product: product.id,
                    amount: product.count
                })
            })

            obj.user_name === '' ? this.errors.name = true : this.errors.name = false
            obj.user_last_name === '' ? this.errors.last_name = true : this.errors.last_name = false
            obj.user_phone === '' ? this.errors.phone = true : this.errors.phone = false
            obj.typeDelivery = {} ? this.errors.delivery = true : this.errors.delivery = false
            obj.delivery_method_id === undefined ? this.errors.delivery = true : this.errors.delivery = false
            obj.payment_method_id === undefined ? this.errors.payment = true : this.errors.payment = false
            obj.address.city === '' ? this.errors.city = true : this.errors.city = false
            obj.post_number === '' ? this.errors.department = true : this.errors.department = false
            obj.address.street === '' ? this.errors.street = true : this.errors.street = false
            obj.address.build === '' ? this.errors.home = true : this.errors.home = false

            if (!this.errors.last_name && !this.errors.name && !this.errors.phone && !this.errors.delivery) {
                if (this.typeDelivery.id === 1) {
                    if (!this.errors.city && !this.errors.department && !this.errors.payment) {
                        if (this.currentPayment.id === 4) {
                            this.submitOrder(obj).then(() => {
                                this.changeShowThanksOrder(true)
                                this.resetBasket()
                                this.orderSent = true
                                console.log('payment4');
                            })
                        }
                        if (this.currentPayment.id === 5) {
                            this.submitOrder(obj)
                            this.orderSent = true
                        }
                    }
                }

                if (this.typeDelivery.id === 2) {
                    if (!this.errors.city && !this.errors.street && !this.errors.home && !this.errors.payment) {
                        if (this.currentPayment.id === 4) {
                            this.submitOrder(obj).then(() => {
                                this.changeShowThanksOrder(true)
                                this.resetBasket()
                                this.orderSent = true
                                console.log('payment4');
                            })
                        }
                        if (this.currentPayment.id === 5) {
                            this.submitOrder(obj)
                            this.orderSent = true
                        }
                    }

                }

                if (this.typeDelivery.id === 3) {
                    if (!this.errors.payment) {
                        if (this.currentPayment.id === 4) {
                            this.submitOrder(obj).then(() => {
                                this.changeShowThanksOrder(true)
                                this.resetBasket()
                                this.orderSent = true
                                console.log('payment4');
                            })
                        }
                        if (this.currentPayment.id === 5) {
                            this.submitOrder(obj)
                            this.orderSent = true
                        }
                    }
                }
            }

        }

    },
    created() {
        this.orderMethods().then(() => {
            if (this.ordersMethods && this.ordersMethods.length) {
                this.typeDelivery = this.ordersMethods[0]
            }
        })

        // this.getUserData().then(() => {
        //     if (this.getUserInfo) this.userData()
        // })
    }

}



